import { withInstall as o } from "../../utils/with-install.js";
import t from "./popup.vue.js";
/* empty css           */
const i = o(t);
export {
  i as ApPopup,
  i as default
};
